module.exports = __webpack_public_path__ + "assets/images/225c0d0213c8f5b448ee782702113934.png";